import { type Enum } from '@webapp/infrastructure/types/Enum'

export const IntegrationNames = {
  CODAT_DYNAMICS_365_BUSINESS_CENTRAL:
    'urn:integration:backend:codat-dynamics-365-business-central',
  CODAT_NETSUITE: 'urn:integration:backend:codat-netsuite',
  CODAT_QUICKBOOKS_ONLINE: 'urn:integration:backend:codat-quickbooks-online',
  CODAT_QUICKBOOKS_ONLINE_SANDBOX:
    'urn:integration:backend:codat-quickbooks-online-sandbox',
  CODAT_SAGE_INTACCT: 'urn:integration:backend:codat-sage-intacct',
  CODAT_SANDBOX: 'urn:integration:backend:codat-sandbox',
  CODAT_XERO: 'urn:integration:backend:codat-xero',
  NETSUITE: 'urn:integration:backend:netsuite',
  PROCURIFY: 'urn:integration:backend:procurify',
  WORKATO: 'urn:integration:backend:workato',
  MERGE_QUICKBOOKS_ONLINE: 'urn:integration:backend:merge:quickbooks-online',
  MERGE_NETSUITE: 'urn:integration:backend:merge:netsuite',
  MERGE_XERO: 'urn:integration:backend:merge:xero',
  MERGE_SAGE_INTACCT: 'urn:integration:backend:merge:sage-intacct',
  MERGE_BUSINESS_CENTRAL: 'urn:integration:backend:merge:business-central',
} as const

export type IntegrationNameEnum = Enum<typeof IntegrationNames>
